import { cn } from "@/lib/utils";

export const InputRadio = ({ className, children, ...otherProps }: Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">) => {
  return (
    <input type="radio" className={cn("", className)} {...otherProps}>{children}</input>
  );
};